'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./~/_react-slick@0.15.4@react-slick/lib/index.js
// module id = 1581
// module chunks = 1